(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8602],{

/***/ 37561:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search.php",
      function () {
        return __webpack_require__(27682);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PLP_Items_Per_Page; }
/* harmony export */ });
var PLP_Items_Per_Page = 60;


/***/ }),

/***/ 28764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src1242957207_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src1242957207_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src1242957207_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48080);






var kebabCase = function(str) {
    return "".concat(str || "").replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
    .replace(/[\s_]+/g, "-") // replace all spaces and low dash
    .toLowerCase();
};
var usePLPAnalytics = function(param) {
    var cart = param.cart, customer = param.customer, products = param.products, categoryName = param.categoryName, _plpType = param.plpType, plpType = _plpType === void 0 ? "category" : _plpType;
    var PLPAnalytics = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src1242957207_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, getCustomerOrderCount, cartTotal, customerId, customerEmail, impressions, orderCount, sendToGA;
        return _codebuild_output_src1242957207_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (products) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 6;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 7480).then(__webpack_require__.bind(__webpack_require__, 32054)), 
                        ];
                    });
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    getCustomerOrderCount = ref[0].getCustomerOrderCount;
                    cartTotal = (cart === null || cart === void 0 ? void 0 : cart.total.toFixed(2)) || 0;
                    customerId = (customer === null || customer === void 0 ? void 0 : customer.entityId) || 0;
                    customerEmail = (customer === null || customer === void 0 ? void 0 : customer.email) || "";
                    impressions = products.map(function(product, index) {
                        return {
                            name: product.name,
                            id: product.variants[0].sku,
                            price: product.calculated_price,
                            brand: product.brand,
                            category: categoryName,
                            variant: product.variants[0].id,
                            list: kebabCase(categoryName),
                            position: index + 1,
                            reviewCount: product.reviewCount,
                            reviewRating: product.reviewRating
                        };
                    });
                    _ctx.next = 15;
                    return getCustomerOrderCount();
                case 15:
                    orderCount = _ctx.sent;
                    sendToGA = function() {
                        var ref, ref1, ref2, ref3;
                        var collectionView = {
                            event: "collectionView",
                            ecommerce: {
                                currencyCode: "USD",
                                impressions: impressions,
                                customerEmail: customerEmail,
                                customerId: customerId,
                                visitorType: customerId ? "Logged In" : "Guest"
                            },
                            customerEmail: customerEmail,
                            pageName: "plp"
                        };
                        var customerEvent = {
                            event: "customer",
                            visitorType: customerId ? "Logged In" : "Guest",
                            customerId: customerId,
                            customerEmail: customerEmail,
                            customerOrdersCount: orderCount,
                            customerTotalSpent: "",
                            cartTotal: cartTotal,
                            pageType: plpType
                        };
                        window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : (ref1 = ref.push) === null || ref1 === void 0 ? void 0 : ref1.call(ref, collectionView);
                        window === null || window === void 0 ? void 0 : (ref2 = window.dataLayer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.push) === null || ref3 === void 0 ? void 0 : ref3.call(ref2, customerEvent);
                    };
                    if (window.loadedAndInteractive) {
                        sendToGA();
                    } else {
                        window.addEventListener("loadedAndInteractive", sendToGA, {
                            once: true
                        });
                    }
                    _ctx.next = 23;
                    break;
                case 20:
                    _ctx.prev = 20;
                    _ctx.t2 = _ctx["catch"](0);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("PLPAnalytics Error", _ctx.t2);
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                20
            ]
        ]);
    })), [
        cart,
        customer,
        products,
        categoryName,
        plpType
    ]);
    return {
        PLPAnalytics: PLPAnalytics
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (usePLPAnalytics);


/***/ }),

/***/ 20558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nl": function() { return /* binding */ getLongformProseContent; },
  "ag": function() { return /* binding */ getSeoPortions; }
});

// UNUSED EXPORTS: assertLongformProseContent, candidateUrls, longformProseContentChecker, seoFooterEntryWithImageChecker, seoFooterEntryWithoutImageChecker, seoFooterResponseChecker

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@recoiljs/refine/es/index.js
var es = __webpack_require__(30901);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./helpers/withSentryAssertion.ts
var withSentryAssertion = __webpack_require__(32237);
;// CONCATENATED MODULE: ./helpers/assertionOrSilentNull.ts
var assetionOrSilentNull = function(asserter) {
    return function(x) {
        try {
            return asserter(x);
        } catch (e) {
            return null;
        }
    };
};

// EXTERNAL MODULE: ./helpers/allPromisesWithRetries.ts
var allPromisesWithRetries = __webpack_require__(48080);
// EXTERNAL MODULE: ./services/Configuration.js
var Configuration = __webpack_require__(16977);
// EXTERNAL MODULE: ./microFrontends/seoFooter/data/targetCategoryUrls.ts
var targetCategoryUrls = __webpack_require__(68380);
;// CONCATENATED MODULE: ./microFrontends/seoFooter/client.ts










var seoFooterEntryWithImageChecker = (0,es/* object */.Ry)({
    phrase: (0,es/* string */.Z_)(),
    imageUrl: (0,es/* string */.Z_)(),
    url: (0,es/* string */.Z_)(),
    renderableText: (0,es/* string */.Z_)()
});
var seoFooterEntryWithoutImageChecker = (0,es/* object */.Ry)({
    phrase: (0,es/* string */.Z_)(),
    url: (0,es/* string */.Z_)(),
    renderableText: (0,es/* string */.Z_)()
});
var seoFooterResponseChecker = (0,es/* object */.Ry)({
    item: (0,es/* object */.Ry)({
        metaDescription: (0,es/* optional */.jt)((0,es/* union */.G0)((0,es/* string */.Z_)(), (0,es/* literal */.i0)(null))),
        metaTitle: (0,es/* optional */.jt)((0,es/* union */.G0)((0,es/* string */.Z_)(), (0,es/* literal */.i0)(null))),
        description: (0,es/* union */.G0)((0,es/* string */.Z_)(), (0,es/* literal */.i0)(null)),
        name: (0,es/* union */.G0)((0,es/* string */.Z_)(), (0,es/* literal */.i0)(null)),
        material: (0,es/* union */.G0)((0,es/* string */.Z_)(), (0,es/* literal */.i0)(null)),
        size: (0,es/* union */.G0)((0,es/* string */.Z_)(), (0,es/* literal */.i0)(null)),
        color: (0,es/* union */.G0)((0,es/* string */.Z_)(), (0,es/* literal */.i0)(null)),
        finish: (0,es/* union */.G0)((0,es/* string */.Z_)(), (0,es/* literal */.i0)(null)),
        letter: (0,es/* union */.G0)((0,es/* string */.Z_)(), (0,es/* literal */.i0)(null))
    }),
    roomSuitabilityAndStyling: (0,es/* union */.G0)((0,es/* string */.Z_)(), (0,es/* literal */.i0)(null)),
    knownTags: (0,es/* dict */.dz)((0,es/* string */.Z_)()),
    relatedSearches: (0,es/* array */.IX)(seoFooterEntryWithImageChecker),
    goesBestWith: (0,es/* array */.IX)(seoFooterEntryWithoutImageChecker),
    supplementary: (0,es/* array */.IX)(seoFooterEntryWithoutImageChecker)
});
var assertSeoFooterResponse = assetionOrSilentNull((0,withSentryAssertion/* withSentryAssertion */.o)([
    seoFooterResponseChecker,
    "SeoFooterResponse"
]));
var candidateUrls = Object.keys(targetCategoryUrls/* targetCategoryUrls */.w);
var longformProseContentChecker = (0,es/* object */.Ry)({
    title: (0,es/* string */.Z_)(),
    blocks: (0,es/* array */.IX)((0,es/* object */.Ry)({
        heading: (0,es/* string */.Z_)(),
        content: (0,es/* string */.Z_)(),
        link: (0,es/* object */.Ry)({
            url: (0,es/* constraint */.x3)((0,es/* string */.Z_)(), function(s) {
                return candidateUrls.includes(s) ? true : [
                    false,
                    "must EXACTLY match a candidate url slug"
                ];
            }),
            text: (0,es/* string */.Z_)()
        })
    }))
});
var assertLongformProseContent = assetionOrSilentNull((0,withSentryAssertion/* withSentryAssertion */.o)([
    longformProseContentChecker,
    "LongformProseContent"
]));
var getSeoPortions = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sku) {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios_default().get("".concat(Configuration.CDN_API, "/ssr-api/seo-footer/").concat(sku));
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data === null ? null : assertSeoFooterResponse(response.data));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSeoPortions(sku) {
        return _ref.apply(this, arguments);
    };
}();
var getLongformProseContent = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(browseUrlName) {
        var queryWithHyphens, ref, wordBank, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryWithHyphens = browseUrlName.replace(/ /g, "-").toLowerCase().replace(/[^a-z0-9-]/g, "").replace(/-+/g, "-");
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 4;
                    return (0,allPromisesWithRetries/* default */.Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 3864).then(__webpack_require__.bind(__webpack_require__, 23864))
                        ];
                    });
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    wordBank = ref[0].wordBank;
                    if (wordBank.includes(queryWithHyphens)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 9:
                    _ctx.prev = 9;
                    _ctx.next = 12;
                    return axios_default().get("".concat(Configuration.CDN_API, "/ssr-api/seo-content/").concat(queryWithHyphens, ".json"));
                case 12:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data === null ? null : assertLongformProseContent(response.data));
                case 16:
                    _ctx.prev = 16;
                    _ctx.t2 = _ctx["catch"](9);
                    console.error(_ctx.t2);
                    return _ctx.abrupt("return", null);
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                9,
                16
            ]
        ]);
    }));
    return function getLongformProseContent(browseUrlName) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 68380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ targetCategoryUrls; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
// additional category urls

var additionalCategoryUrls = {
    "rugs": 101330,
    "rugs-by-style": 101346,
    "vintage": 101336,
    "outdoor-dining-furniture": 101492,
    "outdoor-accent-tables-chairs": 101494,
    "outdoor-tabletop": 101500,
    "furniture-benches": 119614,
    "outdoor-garden-stools": 101499,
    "outdoor-planters-garden": 118835,
    "brooches-pins": 119323,
    "outdoor-storage-covers": 118832,
    "outdoor-lounge-furniture": 101493,
    "sofas-loveseats": 125631,
    "rugs-by-material": 101345,
    "furniture-ottomans": 119615,
    "dining-sets": 125636,
    "ottomans-poufs-stools": 119615,
    "lighting-lanterns": 119698,
    "scarves": 119342,
    "bar-cocktail-glasses": 119455,
    "pillows": 119258,
    "bottle-openers": 119471,
    "dining-chairs-and-benches": 125637,
    "furniture-bookcases": 119612,
    "jewelry": 119249,
    "bracelets": 119318,
    "champagne-flutes": 119466,
    "wreaths-garlands": 119301,
    "furniture-console-tables": 119610,
    "tablecloths-runners": 119483,
    "bed-bath-shams": 121695,
    "pillows-decor-topiaries-trees": 119300,
    "outdoor-statuary-fountains": 101501,
    "lighting-pendants": 119682,
    "-tag-res": 119661,
    "pillows-decor-decorative-kitchenware": 119284,
    "coverlets": 121708,
    "bookcases-tag-res": 119612,
    "robes-slippers-sleepwear": 121689,
    "candle-holders": 119289,
    "pillows-decor-coasters": 119473
};
var targetCategoryUrls = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    "art-drawings": 101413,
    "art-mirrors-art": 101349,
    "art-mirrors-floor-mirrors": 101418,
    "art-mirrors-maps-flags-posters": 101416,
    "art-mirrors-mirrors": 101351,
    "art-mirrors-mixed-media": 101414,
    "art-mirrors-paintings": 101412,
    "art-mirrors-photography": 101411,
    "art-mirrors-vintage-reproductions": 101415,
    "art-mirrors-wall-mirrors": 101417,
    "art-mirrors-wallpaper": 119242,
    "art-mirrors": 101332,
    "bags-accessories": 119250,
    "bed-bath-accessories": 121692,
    "bed-bath-bath": 121683,
    "bed-bath-beach-towels": 121720,
    "bed-bath-bedding-basics": 121686,
    "bed-bath-bedding": 121682,
    "bed-bath-blankets-quilts": 121687,
    "bed-bath-duvet-covers": 121684,
    "bed-bath-mats": 121691,
    "bed-bath-sheets-pillows": 121685,
    "bed-bath-shower-curtains": 121690,
    "bed-bath-towels": 121688,
    "bed-bath-waste-baskets": 121722,
    "bed-bath": 121681,
    "bistro-tables": 119676,
    "brands-justina-blakeney-amber-lewis-more": 20220712,
    "dash-albert": 20220702,
    "decor-baskets-organization": 119238,
    "decor-books-bookends": 119248,
    "decor-candles-diffusers": 119247,
    "decor-decorative-accents": 119236,
    "decor-desk-stationery": 119251,
    "decor-floral-greenery": 119237,
    "decor-games": 119253,
    "decor-gifts-accessories": 119246,
    "decor-home-accents": 119216,
    "decor-picture-frames": 119235,
    "decor-pillows-throws": 119239,
    "decor-pillows": 119518,
    "decor-planters-garden": 119257,
    "decor-shelving-brackets": 119244,
    "decor-throws": 119529,
    "decor-trays-boxes": 119234,
    "decor-vases-jars": 119233,
    "decor": 119215,
    "furniture-accent-chairs": 119650,
    "furniture-arm-chairs": 119678,
    "furniture-armoires": 119702,
    "furniture-bar-tables": 119677,
    "furniture-barstools-counter-stools": 119622,
    "furniture-bedroom": 119601,
    "furniture-beds": 119628,
    "furniture-benches-banquettes": 119625,
    "furniture-buffets-sideboards": 119623,
    "furniture-cabinets-hutches": 119624,
    "furniture-cabinets": 119613,
    "furniture-center-tables": 119713,
    "furniture-chairs": 119607,
    "furniture-chaise-lounges-daybeds": 119606,
    "furniture-chaise-lounges": 119648,
    "furniture-club-chairs": 119652,
    "furniture-coat-racks-umbrella-stands": 119637,
    "furniture-coat-racks": 119715,
    "furniture-coffee-tables": 119608,
    "furniture-consoles-center-tables": 119636,
    "furniture-daybeds": 119649,
    "furniture-desk-chairs": 119618,
    "furniture-desks": 119617,
    "furniture-dining-chair-sets": 119681,
    "furniture-dining-chairs": 119621,
    "furniture-dining-room": 119600,
    "furniture-dining-tables": 119674,
    "furniture-dressers-armoires": 119631,
    "furniture-dressers": 119701,
    "furniture-end-of-bed": 119634,
    "furniture-entry": 119602,
    "furniture-four-poster-canopy-beds": 119689,
    "furniture-garden-stools": 119666,
    "furniture-hammocks-porch-swings": 119642,
    "furniture-headboards": 119629,
    "furniture-living-room": 119588,
    "furniture-nesting-tables": 119657,
    "furniture-nightstands": 119630,
    "furniture-office": 119599,
    "furniture-other-stools": 119668,
    "furniture-outdoor-dining-furniture": 119640,
    "furniture-outdoor-lounge-furniture": 119639,
    "furniture-panel-beds": 119685,
    "furniture-pedestals-plant-stands": 119638,
    "furniture-plant-stands": 119720,
    "furniture-platform-beds": 119690,
    "furniture-poufs": 119665,
    "furniture-recliners-gliders-swivel-chairs": 119653,
    "furniture-room-screens": 119616,
    "furniture-sectionals": 119605,
    "furniture-settees": 119646,
    "furniture-side-chairs": 119679,
    "furniture-side-tables": 119609,
    "furniture-sideboards-media-storage": 119611,
    "furniture-sleeper-sofas": 119647,
    "furniture-sofas-settees": 119604,
    "furniture-sofas": 127620,
    "furniture-standard-benches": 119709,
    "furniture-standard-side-tables": 119656,
    "furniture-storage-benches": 119708,
    "furniture-storage-furniture-benches": 119635,
    "furniture-storage-furniture": 119707,
    "furniture-tray-tables": 119658,
    "furniture-trunks": 119706,
    "furniture-umbrella-stands": 119716,
    "furniture-vanities-dressing-tables": 119703,
    "furniture-vanities-vanity-stools": 119632,
    "furniture-vanity-stools": 119704,
    "furniture-wingback-beds": 119686,
    "furniture-wingback-chairs": 119651,
    "furniture": 119587,
    "kitchen-islands-carts": 119627,
    "lighting-accessories": 119673,
    "lighting-bath-lights": 119717,
    "lighting-ceiling-lights-fans": 119670,
    "lighting-chandeliers": 119680,
    "lighting-finials": 119722,
    "lighting-floor-lamps": 119711,
    "lighting-flush-mounts": 119683,
    "lighting-picture-lights": 119718,
    "lighting-sconces": 119714,
    "lighting-shades": 119721,
    "lighting-table-floor-lamps": 119671,
    "lighting-table-lamps": 119710,
    "lighting-wall-lighting": 119672,
    "lighting": 119667,
    "outdoor-chairs": 125633,
    "outdoor-doormats": 101505,
    "outdoor-furniture": 101370,
    "outdoor-lighting": 119675,
    "outdoor-ottomans": 125635,
    "outdoor-outdoor-accents": 101371,
    "outdoor-outdoor-lighting": 101373,
    "outdoor-porch-swings": 118837,
    "outdoor-poufs": 125634,
    "outdoor-rugs-doormats": 101372,
    "outdoor-umbrellas-stands": 118838,
    "outdoor": 101338,
    "pillows-decor-beverage-dispensers": 119427,
    "pillows-decor-candlesticks-candelabras": 119292,
    "pillows-decor-decorative-bowls-centerpieces": 119283,
    "pillows-decor-decorative-jars-canisters": 119277,
    "pillows-decor-diffusers-sprays": 119308,
    "pillows-decor-grooming-wellness": 119334,
    "pillows-decor-indoor-games": 119364,
    "pillows-decor-indoor-planters-urns": 119278,
    "pillows-decor-napkin-rings-holders": 119485,
    "pillows-decor-pitchers-carafes": 119428,
    "pillows-decor-tea-cups-saucers": 119470,
    "pillows-decor-travel-accessories": 119341,
    "pillows-decor-travel": 119327,
    "rugs-by-material-hides-sheepskin": 101401,
    "rugs-by-material-natural-fiber": 101400,
    "rugs-by-material-wool": 101399,
    "rugs-by-style-contemporary": 101403,
    "rugs-by-style-global": 101404,
    "rugs-by-style-traditional": 101402,
    "rugs-rug-pads": 101397,
    "tabletop-bar-carts": 119626,
    "tabletop-bar-tools-accessories": 119268,
    "tabletop-dinnerware": 119265,
    "tabletop-drinkware": 119267,
    "tabletop-flatware": 119266,
    "tabletop-serveware": 119264,
    "tabletop-table-kitchen-linens": 119269,
    "tabletop": 119263,
    "visual-comfort": 20220529
}, additionalCategoryUrls);


/***/ }),

/***/ 27682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ search_php; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./hooks/usePLPAnalytics.tsx
var usePLPAnalytics = __webpack_require__(28764);
// EXTERNAL MODULE: ./services/getSiteWideInitialProps.ts + 1 modules
var getSiteWideInitialProps = __webpack_require__(10167);
// EXTERNAL MODULE: ./services/Log.ts
var Log = __webpack_require__(27429);
// EXTERNAL MODULE: ./helpers/allPromisesWithRetries.ts
var allPromisesWithRetries = __webpack_require__(48080);
// EXTERNAL MODULE: ./data/constants/PLP_Items_Per_Page.ts
var PLP_Items_Per_Page = __webpack_require__(6619);
// EXTERNAL MODULE: ./microFrontends/seoFooter/client.ts + 1 modules
var client = __webpack_require__(20558);
// EXTERNAL MODULE: ./helpers/timePromiseAndLog.ts
var timePromiseAndLog = __webpack_require__(60599);
// EXTERNAL MODULE: ./helpers/getServerSideAbExperiment.ts + 1 modules
var getServerSideAbExperiment = __webpack_require__(62186);
// EXTERNAL MODULE: ./services/Configuration.js
var Configuration = __webpack_require__(16977);
// EXTERNAL MODULE: ./helpers/FP.ts
var FP = __webpack_require__(13174);
;// CONCATENATED MODULE: ./data/constants/BROWSE_LINK_LIST.ts
var BROWSE_LINK_LIST = [
    {
        "title": "Art & Mirrors",
        "values": [
            "bathroom-mirrors",
            "art-prints",
            "metal-wall-art",
            "large-wall-art",
            "canvas-wall-art",
            "wall-mirrors",
            "poster-prints",
            "vanity-mirrors",
            "framed-prints",
            "decorative-mirrors",
            "fine-art-prints",
            "big-wall-art",
            "floor-mirrors",
            "oversized-wall-art",
            "full-length-mirrors",
            "large-canvas-art",
            "extra-large-wall-art",
            "large-mirrors",
            "acrylic-wall-art",
            "western-wall-art",
            "modern-mirrors",
            "contemporary-wall-art",
            "woven-wall-art",
            "giant-wall-art",
            "huge-wall-art",
            "arched-mirrors",
            "vinyl-wall-art",
            "oversized-mirrors",
            "standing-mirrors",
            "botanical-art-prints",
            "rustic-mirrors",
            "framed-botanical-prints",
            "coastal-mirrors",
            "white-mirrors"
        ]
    },
    {
        "title": "Bedroom Furniture",
        "values": [
            "bedroom-sets",
            "white-dresser",
            "murphy-beds",
            "queen-headboard",
            "king-headboard",
            "bedroom-dresser",
            "bedroom-furniture-sets",
            "black-nightstand",
            "floating-nightstand",
            "modern-dresser",
            "king-size-bedroom-sets",
            "small-nightstand",
            "nursery-dresser",
            "white-bedroom-set",
            "full-size-bedroom-sets",
            "mirrored-dresser",
            "modern-bedroom-furniture",
            "tall-nightstand",
            "modern-platform-bed",
            "california-king-bedroom-sets",
            "mirrored-nightstand",
            "mid-century-modern-bedroom-set",
            "charging-nightstand",
            "contemporary-bedroom-furniture",
            "luxury-bedroom-furniture",
            "white-queen-bedroom-set",
            "white-king-bedroom-set",
            "king-size-bedroom-suite",
            "modern-upholstered-bed",
            "black-queen-bedroom-set",
            "king-size-headboard-with-storage",
            "modern-storage-bed",
            "scandinavian-bedroom-furniture"
        ]
    },
    {
        "title": "Decor",
        "values": [
            "wall-murals",
            "desk-accessories",
            "boho-throw-pillows",
            "lumbar-pillows",
            "desk-plants",
            "desk-organizers",
            "decorative-throw-pillows",
            "velvet-pillows",
            "desk-risers",
            "bolster-pillows",
            "floral-throw-pillows",
            "velvet-throw-pillows",
            "ceramic-garden-stool",
            "designer-throw-pillows",
            "round-throw-pillows",
            "farmhouse-throw-pillows",
            "luxury-throw-pillows",
            "personalized-throw-pillows",
            "luxury-desk-accessories"
        ]
    },
    {
        "title": "Dining Room Furniture",
        "values": [
            "bar-stools",
            "bar-cart",
            "dining-room-sets",
            "dining-chairs",
            "round-dining-table",
            "counter-stools",
            "extendable-dining-table",
            "counter-height-bar-stools",
            "small-kitchen-table",
            "oval-dining-table",
            "modern-dining-table",
            "dining-set",
            "farmhouse-dining-table",
            "kitchen-tables",
            "marble-dining-table",
            "dining-tables",
            "drop-leaf-table",
            "upholstered-dining-chairs",
            "glass-dining-table",
            "solid-wood-dining-table",
            "counter-height-dining-set",
            "white-dining-table",
            "rattan-dining-chairs",
            "square-dining-table",
            "leather-dining-chairs",
            "kitchen-bar-stools",
            "expandable-dining-table",
            "gold-bar-cart",
            "leather-bar-stools",
            "bar-furniture",
            "counter-height-dining-table",
            "marble-top-dining-table",
            "drop-leaf-dining-table",
            "round-pedestal-dining-table",
            "breakfast-nook-dining-set",
            "farmhouse-dining-set",
            "metal-dining-chairs",
            "swivel-counter-stools",
            "white-oak-dining-table",
            "home-bar-furniture",
            "wicker-dining-chairs",
            "bar-height-dining-table",
            "adjustable-bar-stools",
            "expandable-table",
            "glass-top-dining-table",
            "leather-counter-stools",
            "counter-height-stools-with-backs",
            "home-bar-cabinet",
            "backless-bar-stools",
            "marble-dining-table-set",
            "trestle-dining-table",
            "space-saving-dining-table",
            "mini-bar-cart",
            "pub-tables",
            "faux-leather-dining-chairs",
            "backless-counter-stools",
            "solid-oak-dining-table",
            "windsor-dining-chairs",
            "butterfly-leaf-dining-table",
            "breakfast-nook-set",
            "faux-marble-dining-table",
            "counter-height-kitchen-table",
            "farmhouse-dining-room-table",
            "round-pedestal-table",
            "wine-bar-cabinet",
            "luxury-dining-table",
            "grey-dining-table",
            "6-piece-dining-set",
            "bistro-sets",
            "wood-bar-cart",
            "marble-round-dining-table",
            "convertible-dining-table",
            "bar-sets",
            "drop-leaf-kitchen-table",
            "upholstered-counter-stools",
            "8-piece-dining-set",
            "breakfast-bar-stools",
            "marble-dining-room-table",
            "extendable-dining-room-table",
            "wooden-counter-stools",
            "bamboo-dining-chairs",
            "rattan-dining-table",
            "custom-dining-table",
            "extension-table",
            "breakfast-nook-tables",
            "ladder-back-dining-chairs",
            "parsons-dining-chairs",
            "foldable-kitchen-table",
            "farmhouse-kitchen-chairs",
            "expanding-dining-table",
            "commercial-bar-furniture",
            "seagrass-dining-chairs",
            "industrial-bar-cart"
        ]
    },
    {
        "title": "Entryway Furniture",
        "values": [
            "entryway-furniture",
            "entryway-tables",
            "foyer-tables",
            "entryway-mirrors"
        ]
    },
    {
        "title": "Furniture",
        "values": [
            "modern-furniture",
            "scandinavian-furniture",
            "rustic-furniture",
            "leather-furniture",
            "contemporary-furniture",
            "coastal-furniture",
            "farmhouse-furniture",
            "mission-style-furniture",
            "clearance-furniture",
            "space-saving-furniture",
            "custom-furniture",
            "designer-furniture",
            "retro-furniture",
            "apartment-size-furniture"
        ]
    },
    {
        "title": "Lighting",
        "values": [
            "floor-lamps",
            "table-lamps",
            "desk-lamps",
            "table-lamps-for-living-room",
            "modern-floor-lamps",
            "floor-lamp-with-table",
            "bedside-table-lamps",
            "brass-floor-lamp",
            "modern-wall-sconces",
            "island-lighting",
            "path-lights",
            "living-room-table-lamps",
            "bedroom-wall-sconces",
            "bathroom-chandeliers",
            "flush-mount-ceiling-lights",
            "vintage-floor-lamps",
            "drum-chandelier",
            "bathroom-wall-sconces",
            "antique-floor-lamps",
            "visual-comfort-sconces",
            "lantern-pendant-light",
            "farmhouse-table-lamps",
            "ceramic-table-lamps",
            "mid-century-modern-table-lamps",
            "glass-table-lamps",
            "tall-floor-lamps",
            "rustic-table-lamps",
            "vintage-pendant-lighting",
            "tiffany-floor-lamps",
            "hallway-ceiling-lights",
            "contemporary-chandeliers",
            "tiffany-table-lamps",
            "coastal-light-fixtures",
            "contemporary-table-lamps",
            "crystal-pendant-lighting",
            "plug-in-wall-sconces",
            "kitchen-island-chandelier",
            "crystal-table-lamps",
            "ceiling-fan-light-kits",
            "coastal-table-lamps",
            "arc-floor-lamps",
            "kitchen-chandeliers",
            "coastal-floor-lamps",
            "black-chandeliers",
            "tiffany-style-table-lamps",
            "brass-table-lamps",
            "chandelier-light-fixtures",
            "rustic-floor-lamps",
            "drum-pendant-lighting",
            "led-floor-lamps",
            "rustic-ceiling-lights",
            "farmhouse-pendant-lighting",
            "art-deco-table-lamps",
            "reading-floor-lamps",
            "vintage-chandeliers",
            "mid-century-modern-wall-sconces",
            "motion-sensor-lighting",
            "glass-pendant-lighting",
            "brass-chandeliers",
            "black-floor-lamps",
            "brass-floor-lamps",
            "drum-shade-chandelier",
            "buffet-table-lamps",
            "tripod-floor-lamps",
            "gold-chandeliers",
            "post-light-fixtures",
            "black-table-lamps",
            "battery-powered-light-fixtures",
            "contemporary-floor-lamps",
            "gold-floor-lamps",
            "mini-pendant-lighting",
            "traditional-table-lamps",
            "black-wall-sconces",
            "wood-table-lamps",
            "semi-flush-mount-ceiling-lights",
            "farmhouse-floor-lamps",
            "wooden-floor-lamps",
            "home-lighting-fixtures",
            "white-floor-lamps",
            "wood-chandeliers",
            "contemporary-wall-sconces",
            "usb-table-lamps"
        ]
    },
    {
        "title": "Living Room Furniture",
        "values": [
            "accent-chairs",
            "tv-stands",
            "sectional-couches",
            "sectional-sofas",
            "recliners",
            "coffee-tables",
            "living-room-sets",
            "lift-top-coffee-table",
            "futons",
            "marble-coffee-table",
            "sofa-beds",
            "square-coffee-table",
            "massage-chairs",
            "small-coffee-table",
            "console-tables",
            "recliner-chairs",
            "swivel-accent-chair",
            "sleeper-sofas",
            "narrow-side-table",
            "loveseats",
            "sofa-tables",
            "entertainment-centers",
            "large-coffee-table",
            "living-room-end-tables",
            "leather-accent-chair",
            "c-shaped-side-table",
            "coffee-table-sets",
            "leather-sofas",
            "sofa-sets",
            "sofa-side-table",
            "reclining-sofas",
            "velvet-accent-chair",
            "industrial-coffee-table",
            "power-lift-chairs",
            "oversized-chairs",
            "small-sofas",
            "round-accent-table",
            "sleeper-couches",
            "reclining-couches",
            "recliners-for-tall-people",
            "nesting-end-tables",
            "chairside-table",
            "luxury-sofas",
            "fabric-sofas",
            "narrow-end-tables",
            "leather-club-chairs",
            "couch-and-loveseat-sets",
            "oversized-couches",
            "chesterfield-sofas",
            "futon-frames",
            "leather-sofa-sets",
            "modern-sofa-sets",
            "metal-end-tables",
            "mid-century-modern-couches",
            "reclining-sofa-sets",
            "clearance-sofas",
            "club-chair-with-ottoman",
            "corner-accent-table",
            "oversized-sofas",
            "living-room-sofa-sets",
            "convertible-couches",
            "industrial-side-table",
            "sectional-sofas-for-small-spaces",
            "wingback-accent-chair"
        ]
    },
    {
        "title": "Office Furniture",
        "values": [
            "office-chairs",
            "office-furniture",
            "desk-chairs",
            "bookcases",
            "office-desks",
            "home-office-furniture",
            "home-office-desks",
            "modern-office-furniture",
            "home-office-chairs",
            "office-desk-furniture",
            "executive-desks",
            "office-desk-chairs",
            "executive-office-furniture",
            "modern-office-chairs",
            "desk-furniture",
            "office-workstations",
            "modern-office-desks",
            "white-office-furniture",
            "office-sets",
            "luxury-office-furniture",
            "home-office-sets",
            "office-bookcases",
            "white-office-chairs"
        ]
    },
    {
        "title": "Outdoor",
        "values": [
            "patio-furniture",
            "outdoor-rugs",
            "outdoor-patio-furniture",
            "patio-chairs",
            "outdoor-cushions",
            "outdoor-string-lights",
            "outdoor-pillows",
            "outdoor-chair-cushions",
            "patio-cushions",
            "rattan-furniture",
            "outdoor-lounge-chairs",
            "outdoor-planters",
            "patio-furniture-covers",
            "deck-furniture",
            "patio-umbrellas",
            "patio-dining-sets",
            "patio-sets",
            "outdoor-bar-stools",
            "indoor-outdoor-rugs",
            "outdoor-dining-chairs",
            "outdoor-wall-decor",
            "outdoor-fountains",
            "outdoor-dining-sets",
            "outdoor-cushion-covers",
            "porch-swings",
            "outdoor-folding-chairs",
            "outdoor-patio-rugs",
            "outdoor-chandelier",
            "patio-rugs",
            "outdoor-benches",
            "outdoor-wall-art",
            "outdoor-throw-pillows",
            "garden-stool",
            "patio-curtains",
            "patio-tables",
            "outdoor-bar-cart",
            "outdoor-rocking-chairs",
            "outdoor-patio-cushions",
            "outdoor-dining-furniture",
            "outdoor-mats",
            "patio-conversation-sets",
            "outdoor-door-mats",
            "patio-lounge-chairs",
            "outdoor-post-lights",
            "outdoor-conversation-sets",
            "outdoor-lounge-furniture",
            "outdoor-side-tables",
            "outdoor-lamps",
            "patio-rocking-chairs",
            "porch-rocking-chairs",
            "patio-dining-chairs",
            "outdoor-lumbar-pillows",
            "outdoor-plant-stands",
            "outdoor-bench-cushions",
            "sunbrella-outdoor-pillows",
            "outdoor-statues",
            "outdoor-pendant-lighting",
            "patio-pillows",
            "outdoor-sofa-cushions",
            "outdoor-swing-sets",
            "outdoor-sectional-furniture",
            "patio-swings",
            "glider-chairs",
            "outdoor-gazebos",
            "outdoor-sofas",
            "outdoor-flags",
            "outdoor-ottomans",
            "outdoor-dining-sets-for-8",
            "outdoor-coffee-tables",
            "patio-side-tables",
            "outdoor-bar-furniture",
            "outdoor-flush-mount-light",
            "outdoor-recliners",
            "deck-umbrellas",
            "patio-gazebos",
            "outdoor-patio-bar",
            "patio-end-tables",
            "outdoor-daybeds",
            "outdoor-patio-dining-sets",
            "outdoor-chaise-lounges",
            "patio-dining-tables",
            "outdoor-gliders",
            "outdoor-bean-bags",
            "patio-sectionals",
            "outdoor-wall-light-fixtures",
            "outdoor-loveseats",
            "outdoor-chandeliers",
            "outdoor-bar-sets",
            "outdoor-metal-art",
            "outdoor-chaise-cushions",
            "outdoor-lounge-cushions",
            "outdoor-poufs",
            "outdoor-bistro-sets",
            "patio-gliders",
            "outdoor-picnic-tables",
            "outdoor-tablecloths",
            "deck-rugs",
            "outdoor-deep-seat-cushions",
            "outdoor-sculptures",
            "conversation-sets",
            "jute-outdoor-rug",
            "brass-outdoor-lighting",
            "patio-lamp",
            "patio-bistro-sets",
            "patio-coffee-tables",
            "coastal-outdoor-lighting",
            "large-outdoor-light-fixtures"
        ]
    },
    {
        "title": "Rugs",
        "values": [
            "door-mats",
            "entryway-rugs",
            "blue-area-rugs",
            "personalized-door-mat",
            "contemporary-area-rugs",
            "handmade-persian-rugs",
            "monogrammed-door-mat"
        ]
    },
    {
        "title": "Tabletop & Bar",
        "values": [
            "best-dinnerware-sets",
            "stoneware-dinnerware-sets",
            "ceramic-dinnerware-sets",
            "square-dinnerware-sets",
            "glass-dinnerware-set",
            "vintage-dinnerware-sets",
            "chip-resistant-dinnerware",
            "lead-free-dinnerware",
            "unique-dinnerware-sets"
        ]
    }
];

;// CONCATENATED MODULE: ./services/restrictBrowsePageUsageToWhitelist.ts

var restrictBrowsePageUsageToWhitelist = function(param) {
    var _asPath = param.asPath, asPath = _asPath === void 0 ? "" : _asPath, res = param.res;
    var isBrowsePage = asPath.includes("/browse/");
    if (!isBrowsePage) {
        return;
    }
    var postBrowseComponent = asPath.split("/browse/").pop() || "";
    var isAllowedBrowse = BROWSE_LINK_LIST.some(function(list) {
        return list.values.some(function(value) {
            return value === postBrowseComponent;
        });
    });
    if (!isAllowedBrowse) {
        res === null || res === void 0 ? void 0 : res.setHeader("X-Robots-Tag", "noindex, nofollow");
        res === null || res === void 0 ? void 0 : res.writeHead(301, {
            Location: "/",
            "cache-control": "public, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0",
            "X-Robots-Tag": "noindex, nofollow"
        }).end();
    }
};

;// CONCATENATED MODULE: ./pages/search.php.tsx
/* provided dependency */ var process = __webpack_require__(34155);



















var Default = dynamic_default()(__webpack_require__.e(/* import() */ 6872).then(__webpack_require__.bind(__webpack_require__, 16872)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16872)
            ];
        }
    }
});
var PLP = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(8924), __webpack_require__.e(6465), __webpack_require__.e(9527)]).then(__webpack_require__.bind(__webpack_require__, 56465)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56465)
            ];
        }
    }
});
var SearchPage = function(param) {
    var QueryParam = param.QueryParam, currentPage = param.currentPage, longformProse = param.longformProse, sitewideBanner = param.sitewideBanner, megaNav = param.megaNav, itemsPerPage = param.itemsPerPage, userAgent = param.userAgent, products = param.products, facets = param.facets, total = param.total, sort = param.sort, eventBanner = param.eventBanner, footer = param.footer, shouldTrackOnBloomreach = param.shouldTrackOnBloomreach, serverSideOpenSearchAB = param.serverSideOpenSearchAB;
    var ref, ref1;
    (0,getServerSideAbExperiment/* useServerSideAbExperiment */.R)({
        ctx: undefined,
        cookieName: "openSearchAB",
        cookieFeature: "isOpenSearchABEnabled",
        experimentId: Configuration.OPENSERARCH_EXPERIMENT_ID,
        serverSideValue: serverSideOpenSearchAB
    });
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,getSiteWideInitialProps.useClientSideCartAndUser)(), cart = ref3.cart, setCart = ref3.setCart, user = ref3.user, reloadCustomer = ref3.reloadCustomer;
    var title = QueryParam.query || "";
    var PLPAnalytics = (0,usePLPAnalytics/* default */.Z)({
        plpType: "search",
        cart: cart,
        customer: user,
        products: products,
        categoryName: title
    }).PLPAnalytics;
    (0,react.useEffect)(function() {
        PLPAnalytics();
    }, [
        products,
        cart,
        PLPAnalytics
    ]);
    var metaTags = {
        description: "Shop One Kings Lane ".concat(title, " | Luxurious and Stylish Home Furnishings"),
        title: title
    };
    var fallBackQuery =  true && ((ref = window.location.search.split("?")) === null || ref === void 0 ? void 0 : (ref1 = ref[1]) === null || ref1 === void 0 ? void 0 : ref1.split("&").find(function(q) {
        return q.startsWith("query");
    })) || "query=".concat((QueryParam === null || QueryParam === void 0 ? void 0 : QueryParam.query) || "");
    var query = QueryParam.query ? "query=".concat(QueryParam.query) : fallBackQuery;
    var baseHref = "/search.php?".concat(query, "&");
    var baseUrl = baseHref;
    (0,react.useEffect)(function() {
        try {
            if (!products) {
                return;
            }
            var content_ids = products.map(function(param) {
                var sku = param.sku;
                return sku;
            });
            var contents = products.map(function(param) {
                var sku = param.sku;
                return {
                    id: sku,
                    quantity: 1,
                    item_price: null
                };
            });
            (0,allPromisesWithRetries/* default */.Z)(function() {
                return [
                    __webpack_require__.e(/* import() */ 9366).then(__webpack_require__.bind(__webpack_require__, 11267))
                ];
            }).then(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), Facebook = _param[0].Facebook;
                return Facebook.search({
                    search_string: (QueryParam === null || QueryParam === void 0 ? void 0 : QueryParam.query) || "",
                    content_ids: content_ids,
                    contents: contents
                });
            }).catch(Log/* error */.vU);
        } catch (err) {
            (0,Log/* error */.vU)("Facebook Pixel Error Failed to send Search event", err);
        }
    }, [
        QueryParam === null || QueryParam === void 0 ? void 0 : QueryParam.query,
        products,
        query,
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default, {
        shouldUsePageView: false,
        reloadCustomer: reloadCustomer,
        user: user,
        sitewideBanner: sitewideBanner,
        megaNav: megaNav,
        meta: metaTags,
        cart: cart,
        onUpdateCart: setCart,
        eventBanner: eventBanner,
        maybeFooterFromContentful: footer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PLP, {
            user: user,
            reloadCustomer: reloadCustomer,
            itemsPerPage: itemsPerPage,
            baseHref: baseHref,
            baseUrl: baseUrl,
            currentPage: currentPage,
            products: products,
            showBreadcrumbs: false,
            PLPHeader: title,
            totalNumberOfProducts: total,
            facets: facets,
            queryParam: QueryParam,
            userAgent: userAgent,
            isCategoryEvent: false,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            sortValue: sort,
            longformProse: longformProse,
            shouldTrackOnBloomreach: shouldTrackOnBloomreach,
            plpSource: "search",
            plpSourceId: query
        })
    });
};
SearchPage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ctx) {
        var req, res, query, _asPath, asPath, pathReplaced, coalescedQuery, stringQuery, pathOrQueryFormNormalized, appendFakeQueryParamSuffix, path, currentPage, ref, getWindowAgent, ref1, getSiteWideInitialProps, SiteWideInitialPropsFailure, getRefererString, getBloomreachConfig, getQueryXssEscaped, fetchAndProcessSearchPageProducts, legalQuery, userAgent, ref2, itemsPerPageFromQueryParam, itemsPerPage, searchMethodFromQueryParam, searchMethodParam, serverSideOpenSearchAB, ref3, siteWideInitialProps, longformProse, productsResponse, ref4, products, facets, total, searchMethodResponse, safeSearchMethodResponse, isBrowsePage;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    req = ctx.req, res = ctx.res, query = ctx.query, _asPath = ctx.asPath, asPath = _asPath === void 0 ? "" : _asPath;
                    restrictBrowsePageUsageToWhitelist(ctx);
                    if (typeof process !== "undefined" && !true) {}
                    pathReplaced = asPath.replace(/^(\/c-[a-z-]+)\//, "$1");
                    coalescedQuery = (query === null || query === void 0 ? void 0 : query.query) || "";
                    stringQuery = typeof coalescedQuery === "string" ? coalescedQuery : coalescedQuery.join(",");
                    pathOrQueryFormNormalized = decodeURIComponent(asPath.startsWith("/browse") ? stringQuery.replace(/-/g, " ") : stringQuery);
                    appendFakeQueryParamSuffix = pathReplaced.includes("?") ? "&" : "?";
                    path = pathReplaced.startsWith("/browse") ? "".concat(pathReplaced).concat(appendFakeQueryParamSuffix, "query=").concat(pathOrQueryFormNormalized) : pathReplaced;
                    currentPage = parseInt("".concat(String(query === null || query === void 0 ? void 0 : query.page) || "")) || 1;
                    (0,Log/* log */.cM)("Category Page getServerSideProps ".concat(JSON.stringify({
                        path: path,
                        asPath: asPath
                    })));
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 14;
                    return (0,allPromisesWithRetries/* default */.Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 7480).then(__webpack_require__.bind(__webpack_require__, 32054)),
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 10167)),
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84295)),
                            __webpack_require__.e(/* import() */ 1588).then(__webpack_require__.bind(__webpack_require__, 55272)),
                            Promise.all(/* import() */[__webpack_require__.e(8924), __webpack_require__.e(5622)]).then(__webpack_require__.bind(__webpack_require__, 55622)),
                            Promise.all(/* import() */[__webpack_require__.e(2526), __webpack_require__.e(9013)]).then(__webpack_require__.bind(__webpack_require__, 69013)), 
                        ];
                    });
                case 14:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 6);
                    getWindowAgent = ref[0].getWindowAgent;
                    ref1 = ref[1];
                    getSiteWideInitialProps = ref1.getSiteWideInitialProps;
                    SiteWideInitialPropsFailure = ref1.SiteWideInitialPropsFailure;
                    getRefererString = ref[2].getRefererString;
                    getBloomreachConfig = ref[3].getBloomreachConfig;
                    getQueryXssEscaped = ref[4].getQueryXssEscaped;
                    fetchAndProcessSearchPageProducts = ref[5].fetchAndProcessSearchPageProducts;
                    legalQuery = getQueryXssEscaped((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                        query: pathOrQueryFormNormalized
                    }));
                    userAgent = getWindowAgent(req) || "";
                    _ctx.prev = 26;
                    ;
                    itemsPerPageFromQueryParam = query.limit;
                    itemsPerPage = (typeof itemsPerPageFromQueryParam === "string" ? parseInt(itemsPerPageFromQueryParam) : 0) || PLP_Items_Per_Page/* PLP_Items_Per_Page */.W;
                    searchMethodFromQueryParam = query.searchMethod;
                    searchMethodParam = typeof searchMethodFromQueryParam === "string" ? searchMethodFromQueryParam : "default";
                    (0,Log/* log */.cM)("query", legalQuery);
                    serverSideOpenSearchAB = (0,getServerSideAbExperiment/* getServerSideAbExperiment */.T)({
                        ctx: {
                            req: req,
                            res: res
                        },
                        cookieName: "openSearchAB",
                        cookieFeature: "isOpenSearchABEnabled",
                        experimentId: Configuration.OPENSERARCH_EXPERIMENT_ID
                    });
                    _ctx.t2 = _sliced_to_array/* default */.Z;
                    _ctx.next = 37;
                    return Promise.all([
                        (0,timePromiseAndLog/* timePromiseAndLog */.Q)("SearchPage.getInitialProps.getSiteWideInitialProps")(getSiteWideInitialProps(ctx, serverSideOpenSearchAB)),
                        // make this query to the seo content chunks on the CDN
                        (0,timePromiseAndLog/* timePromiseAndLog */.Q)("SearchPage.getInitialProps.getLongformProseContent")((0,client/* getLongformProseContent */.Nl)(legalQuery.query || "")),
                        (0,timePromiseAndLog/* timePromiseAndLog */.Q)("SearchPage.getInitialProps.fetchAndProcessSearchPageProducts")(fetchAndProcessSearchPageProducts({
                            asPath: path,
                            query: legalQuery,
                            referer: getRefererString(req === null || req === void 0 ? void 0 : (ref2 = req.headers) === null || ref2 === void 0 ? void 0 : ref2.referer),
                            searchMethod: searchMethodParam,
                            bloomreachConfig: getBloomreachConfig(ctx, serverSideOpenSearchAB)
                        })), 
                    ]);
                case 37:
                    _ctx.t3 = _ctx.sent;
                    ref3 = (0, _ctx.t2)(_ctx.t3, 3);
                    siteWideInitialProps = ref3[0];
                    longformProse = ref3[1];
                    productsResponse = ref3[2];
                    ref4 = productsResponse !== null && productsResponse !== void 0 ? productsResponse : {}, products = ref4.products, facets = ref4.facets, total = ref4.total, searchMethodResponse = ref4.searchMethod;
                    (0,Log/* debug */.fF)("longformProse", longformProse);
                    safeSearchMethodResponse = (0,FP/* nullish */.NZ)(searchMethodResponse)("default");
                    isBrowsePage = asPath.includes("/browse");
                    return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        QueryParam: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, legalQuery), {
                            searchMethod: safeSearchMethodResponse
                        })
                    }, siteWideInitialProps), {
                        longformProse: longformProse,
                        facets: facets,
                        path: path,
                        total: total,
                        currentPage: currentPage,
                        itemsPerPage: itemsPerPage,
                        userAgent: userAgent,
                        asPath: asPath,
                        products: products,
                        shouldTrackOnBloomreach: !isBrowsePage,
                        serverSideOpenSearchAB: serverSideOpenSearchAB
                    }));
                case 49:
                    _ctx.prev = 49;
                    _ctx.t4 = _ctx["catch"](26);
                    (0,Log/* log */.cM)("Cannot get initial props in category page, redirecting", _ctx.t4);
                    res === null || res === void 0 ? void 0 : res.writeHead(302, {
                        Location: "/",
                        "cache-control": "public, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0"
                    });
                    res === null || res === void 0 ? void 0 : res.end();
                    return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        QueryParam: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, legalQuery), {
                            searchMethod: "default"
                        }),
                        path: path,
                        products: [],
                        facets: [],
                        total: 0,
                        currentPage: currentPage,
                        itemsPerPage: PLP_Items_Per_Page/* PLP_Items_Per_Page */.W
                    }, SiteWideInitialPropsFailure), {
                        userAgent: userAgent,
                        longformProse: null,
                        asPath: "",
                        shouldTrackOnBloomreach: false
                    }));
                case 55:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                26,
                49
            ]
        ]);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var search_php = (SearchPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,8309,8764,6337,6862,2186,9774,2888,179], function() { return __webpack_exec__(37561); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);